<stages-description-view [html]="displayDescription.html"></stages-description-view>
